import Vue from 'vue'
import Vuex from 'vuex'
import ResetStore from './plugins/ResetStore'

import mutations from './mutations'
import getters from './getters'
import actions from './actions'

// Modules
import createPersistedState from 'vuex-persistedstate'
import DocumentsModule from '@/modules/Documents/store'
import AuthModule from '@/modules/Auth/store'
import LicensesModule from '@/modules/Licenses/store'
import HomeModule from '@/modules/Home/store'
import SichernConnectModule from '@/vuex/modules/sichernConnect'

Vue.use(Vuex)

const state = {
  user: {},
  usersRelated: {},
  actions: {},
  profile: {},
  config:{},
  jwt: '',
  checkUserEmployee: false,
  // loadingStatus: false,
  timerSweetAlert: 1200,
  stateNotOnboarding: false,
  locale: 'ar',
  documentsFiltersFolders: [],
  documentsFiltersDate: {
    from: '',
    to: ''
  },
  userDocumentsTotal: [],
  userFoldersDocuments: [],
  unsignedTotalDocsLength: 0,
  avatarImage: '',
  hasIntegrationSichernPeople: false,
  hasIntegrationSichernConnect: false,
  goBackCameraHandler: true,
  company: {
    logo: ''
  },
  colors:{},
  companyLoginUrl: '',
  prevRoute: '',
  isManagerRole: true,
  hasAcceptedAITermsAndConditions: {},
  linkUserMergeCandidates: [],
  payrollStatus: false,
  linkKeycloakResult: null,
  managerTasksPending: 0,
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    auth: AuthModule,
    documents: DocumentsModule,
    licenses: LicensesModule,
    home: HomeModule,
    sichernConnect: SichernConnectModule
  },
  plugins: [ResetStore(), createPersistedState({ key: 'vuex-empleado' })],
  strict: false //In strict mode, whenever Vuex state is mutated outside of mutation handlers, an error will be thrown.
})

export default store
